<template>
    <div
        v-show="visible"
        :class="['node-tooltip bottom', className]"
        :style="tooltipStyle"
    >
        <slot>{{ content }}</slot>
        <div class="tooltip__arrow"></div>
    </div>
</template>

<script>
export default {
    name: 'Tooltip',
    props: {
        content: {
            type: String,
            default: '',
        },
        position: {
            type: Object,
            default: () => ({ left: 0, top: 0 }),
        },
        visible: {
            type: Boolean,
            default: false,
        },
        className: {
            type: String,
            default: '',
        }
    },
    computed: {
        tooltipStyle() {
            const { left, top } = this.position;
            return {
                top: `${top + 20}px`,
                left: `${left}px`,
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.node-tooltip {
    position: absolute;
    background: #fff;
    max-width: 220px;
    min-width: 150px;
    word-break: break-all;
    border-radius: 4px;
    border: 1px solid #ebeef5;
    padding: 12px;
    z-index: 2;
    color: #606266;
    line-height: 1.4;
    text-align: justify;
    font-size: 14px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
    &.bottom {
        .tooltip__arrow {
            top: -6px;
            left: 20%;
            margin-right: 3px;
            border-width: 6px;
            border-top-width: 0;
            border-bottom-color: #ebeef5;
        }
        .tooltip__arrow::after {
            top: 1px;
            margin-left: -6px;
            border-top-width: 0;
            border-bottom-color: #fff;
        }
    }
}
.tooltip__arrow, .tooltip__arrow::after {
    position: absolute;
    display: block;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
}

.tooltip__arrow::after {
    content: " ";
    border-width: 6px;
}

</style>
